import Settings from './Dayoffribeirao';

const settings = new Settings();

export default class Config {
    PEDSEGURO_INDOOR = 0;
    CONTROL_CENTER_M10 = 1;
    CONTROL_CENTER_ELGINPAY = 2;
    CONTROL_CENTER_WEB = 3;

    BUILD_PRODUCT = this.PEDSEGURO_INDOOR;
    USE_TABLE = settings.USE_TABLE;

    TEST_VERSION = false;
    WIDTH_TRESHOLD = 640;

    PRINTER_POLL_INTERVAL = 10000;  // 10 seconds

    OPEN_PAYMENT = "bill";
    CREDIT_CARD_ELGIN = "credit-elgin";
    DEBIT_CARD_ELGIN = "debit-elgin";

    POSTAL_CODE = settings.POSTAL_CODE;

    HEADER_LOGO_FILE_M10 = settings.HEADER_LOGO_FILE_M10;
    HEADER_LOGO_FILE_ELGINPAY = settings.HEADER_LOGO_FILE_ELGINPAY;
    HOME_LOGO = settings.HOME_LOGO;

    CUSTOMER_NAME = settings.CUSTOMER_NAME;
    CUSTOMER_PREFIX = settings.CUSTOMER_PREFIX;
    CUSTOMER_ADDRESS = settings.CUSTOMER_ADDRESS;

    HOME_URL = settings.HOME_URL;
    WC_BASE_URL = settings.HOME_URL + "/wp-json/wc/v3/";
    PS_BASE_URL = settings.HOME_URL + "/wp-json/ps-woo/v1/";

    ORDERS_PATH = 'cog-orders-to-print';
    MARK_PRINTED_PATH = 'cog-mark-order';
  
    CONSUMER_KEY = settings.CONSUMER_KEY;
    CONSUMER_SECRET = settings.CONSUMER_SECRET;

    ACTIVE_CATEGORIES = settings.ACTIVE_CATEGORIES;

    ON_HOLD_COLOR = '#C9B919';
    CANCELLED_COLOR = '#BCBCBC';
    PROCESSING_COLOR = '#5C9CDC';
    COMPLETED_COLOR = '#8CAC2C';
    DISABLED_COLOR = '#9C9C9C';
    IFOOD_COLOR = '#EA1D2C';

    SECTION2_COLOR = settings.SECTION2_COLOR;
}
